<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import Swal from "sweetalert2";
import "driver.js/dist/driver.css"
import {getBaseUrl} from "@/helpers/baseUrl";


import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import moment from "moment";
import Loader from "@/router/views_mobagile/components/loader.vue";


export default {

  components: {
    Loader,
    Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
  },

  data() {
    return {
      title: "Cotação Assíncrona de CT-es (Comparação)",
      items: [
        {
          text: "Administrativo",
          href: "/"
        },
        {
          text: "Cotação Assíncrona de CT-es (Comparação)",
          active: true
        }
      ],
      dataList: null,
      updating: false,
      showModalCriarSinc: false,
      taskConpSincData: {},
      submmitedConc: false,
      showModalTarefa: false,
      idData: '',

    };
  },

  created() {

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
  },

  methods: {

    abrirCotacoes(idTarefa){
      console.log('abrirCotacoes')
      console.log(idTarefa)
      this.showModalTarefa = false
      this.$router.push('/movctecotacomps/list/' + idTarefa)
    },


    confConc(){
      console.log('confConc')
      this.submmitedConc = true
      if (this.taskConpSincData.dataini && this.taskConpSincData.datafim) {
        this.updating = true
        this.showModalCriarSinc = false
        api.post(`${getBaseUrl()}api/mctescompassinc`, {
          taskConpSinc: this.taskConpSincData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.updating = false
          this.atualizaDataList()
        })
      }
    },

    criarSinc(){
      console.log('criarSinc')
      this.taskConpSincData = {}
      this.submmitedConc = false
      this.showModalCriarSinc = true
    },

    formatDate(value) {
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDateTime(value) {
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    carregouGrid(e){
      console.log('carregouGrid')
      this.title = '(' + e.component.totalCount() + ') Cotações Assíncronas de CT-es (Comparação)'
    },

    atualizaDataList(){
      console.log('atualizaDataList')
      this.dataList = new CustomStore({
        key: "_id",
        load: function(loadOptions){
          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/mctescompassinc`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data_base00')
            console.log(response)
            if (response.data.error) {
              Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Erro!',
                text: 'Nenhum registro encontrado.',
                timer: 4000,
                showCancelButton: false,
                showConfirmButton: false
              })
              return {
                data: [],
                totalCount: 0,
              }
            } else {
              return {
                data: response.data[0],
                totalCount: response.data[1],
              }
            }
          })
        },
      })
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      console.log(row)
      this.showModalTarefa = true
      this.taskConpSincData = row.data


      // Swal.fire({
      //   position: "center",
      //   icon: "question",
      //   title: "Exclusão de Tarefa Agendada",
      //   text: "Esta operação é irreversível, tem certeza que deseja continuar?",
      //   confirmButtonText: "Confirmar",
      //   cancelButtonText: "Cancelar",
      //   showCancelButton: true,
      //   showConfirmButton: true,
      // }).then(result => {
      //   this.updating = true
      //   if (result.value) {
      //     api.delete(`${getBaseUrl()}api/mctescompassinc`, {
      //       params: {
      //         'iddata': row.data._id,
      //       }
      //     }).then((res) => {
      //       console.log('then axios delete')
      //       console.log(res.data)
      //       this.updating = false
      //       Swal.fire({
      //         position: "top-end",
      //         icon: "success",
      //         title: "Informação excluída com sucesso",
      //         showConfirmButton: false,
      //         timer: 1500
      //       }).then(
      //           this.atualizaDataList
      //       )
      //     })
      //   }
      // })
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          // console.log('onCellPrepared')
          // console.log(e.data.status)
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'Concluído':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'I':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

  },
};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <DxToolbar >
      <DxItem
          location="before"
          widget="dxButton">
        <DxButton
            icon="plus"
            hint="Nova Sincronização"
            :on-click="criarSinc"/>
      </DxItem>
    </DxToolbar>


    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="mt-2" v-if="!updating">


      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"

          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>


        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            data-field="_id"
            sort-order="desc"
            caption="ID"
            data-type="text"
            alignment="left"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="dataini"
            caption="Início"
            data-type="datetime"
            :format="formatDate"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="datafim"
            caption="Início"
            data-type="datetime"
            :format="formatDate"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="totaldocs"
            caption="Total Documentos"
            data-type="number"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="totalprocessados"
            caption="Processado"
            data-type="number"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="status"
            caption="Status"
            alignment="left"
            data-type="text"/>



        <DxColumn
            data-field="segto"
            caption="Seguimento"
            alignment="left"
            data-type="text"/>


        <DxColumn
            data-field="created_by"
            caption="Usuário"
            alignment="left"
            data-type="text"/>

        <DxColumn
            data-field="@timestamp"
            caption="Data"
            data-type="datetime"
            :format="formatDateTime"
            :allowHeaderFiltering="false"/>


        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>




    <b-modal  size="lg" title="Cotação Assíncrona de CT-e (Comparação)"
              v-model="showModalCriarSinc" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">

              <div class="row mb-2">

                <div class="col-md-6">
                  <label for="dataini">Data Inicial</label>
                  <div class="position-relative">
                    <input
                        id="dataini"
                        type="date"
                        v-model="taskConpSincData.dataini"
                        class="form-control text-end"
                        :class="{'is-invalid': submmitedConc && !taskConpSincData.dataini}"
                        placeholder="Data Inicial"/>
                    <div v-if="submmitedConc && !taskConpSincData.dataini" class="invalid-feedback">
                      <span>Campo Data Inicial obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <label for="datafim">Data Final</label>
                  <div class="position-relative">
                    <input
                        id="datafim"
                        type="date"
                        v-model="taskConpSincData.datafim"
                        class="form-control text-end"
                        :class="{'is-invalid': submmitedConc && !taskConpSincData.datafim}"
                        placeholder="Data Final"/>
                    <div v-if="submmitedConc && !taskConpSincData.datafim" class="invalid-feedback">
                      <span>Campo Data Final obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

              </div>


              <div class="row mb-2">

                <div class="col-md-6">
                  <label for="remetcnpj">CNPJ Remetente (Filtrar Apenas)</label>
                  <div class="position-relative">
                    <input
                        id="remetcnpj"
                        type="text"
                        v-model="taskConpSincData.remetcnpj"
                        class="form-control text-end"
                        placeholder="CNPJ Remetente"/>
                  </div>
                </div>

                <div class="col-md-6">
                  <label for="segto">Seguimento (Filtrar Apenas)</label>
                  <div class="position-relative">
                    <input
                        id="segto"
                        type="text"
                        v-model="taskConpSincData.segto"
                        class="form-control text-end"
                        placeholder="Seguimento"/>
                  </div>
                </div>


              </div>


              <div class="row mb-2">

                <div class="text-end mt-5">
                  <b-button variant="light" @click="showModalCriarSinc = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confConc">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>

            </form>

          </div>
        </div>
      </div>
    </b-modal>




    <b-modal  size="lg" title="Detalhes Cotação Assíncrona de CT-e (Comparação)"
              v-model="showModalTarefa" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">

              <div class="row mb-2">

                <div class="col-md-6">
                  <label for="dataini">Data Inicial</label>
                  <div class="position-relative">
                    <input
                        id="dataini"
                        type="date"
                        v-model="taskConpSincData.dataini"
                        class="form-control text-end"
                        :disabled="true"
                        placeholder="Data Inicial"/>
                  </div>
                </div>

                <div class="col-md-6">
                  <label for="datafim">Data Final</label>
                  <div class="position-relative">
                    <input
                        id="datafim"
                        type="date"
                        v-model="taskConpSincData.datafim"
                        class="form-control text-end"
                        :disabled="true"
                        placeholder="Data Final"/>
                  </div>
                </div>

              </div>


              <div class="row mb-2">

                <div class="col-md-6">
                  <label for="remetcnpj">CNPJ Remetente (Filtrar Apenas)</label>
                  <div class="position-relative">
                    <input
                        id="remetcnpj"
                        type="text"
                        v-model="taskConpSincData.remetcnpj"
                        :disabled="true"
                        class="form-control text-end"
                        placeholder="CNPJ Remetente"/>
                  </div>
                </div>

                <div class="col-md-6">
                  <label for="segto">Seguimento (Filtrar Apenas)</label>
                  <div class="position-relative">
                    <input
                        id="segto"
                        type="text"
                        v-model="taskConpSincData.segto"
                        :disabled="true"
                        class="form-control text-end"
                        placeholder="Seguimento"/>
                  </div>
                </div>


              </div>


              <div class="row mb-2">

                <div class="text-end mt-5">
                  <b-button variant="light" @click="showModalTarefa = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Fechar
                  </b-button>


                  <b-button type="button" variant="success" class="ms-1" @click="abrirCotacoes(taskConpSincData._id)">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Abrir Cotações
                  </b-button>



                </div>
              </div>

            </form>

          </div>
        </div>
      </div>
    </b-modal>


  </Layout>
</template>


<style>
#btnAjuda .dx-icon {
  color: #fff !important;
}
</style>

